import React from 'react';
// import { Link } from 'react-router-dom';
// import Moment from 'react-moment';
// import WithConsumer from '../context/WithConsumer';
import { Link } from 'react-router-dom';
import backIcon from '../images/back.svg';

const BackLink = () => {

    return (<Link to="/" className="header__back-button">
	    	<img alt="Back to homepage" src={backIcon} /><
	    	/Link>);

};
export default BackLink;